export interface WebSocketResponse<T> {
  action: string;
  data: T;
}

export interface DisputeStatusUpdateResponse {
  isDisputeFiled: boolean;
  message: string;
  deductionInfo: {
    deductionId: number;
    claimNumber: string;
    remittanceItemId: number;
  };
  disputeInfo: {
    disputeId: number;
  };
  brandInfo: {
    brandKey: string;
  };
  purchaserInfo: {
    purchaserKey: string;
  };
  userInfo: {
    userId: number;
  };
}

export interface IntelliUploadStatusUpdateResponse {
  documentId: number;
  claimNumber: string | null;
  checkNumber: string | null;
}

export interface BackupRequestStatusUpdateResponse {
  isBackupRequested: boolean;
  requestType: string;
  message: string;
  deductionInfo: {
    deductionId: number;
    claimNumber: string;
    remittanceItemId: number;
  };
  disputeInfo: {
    disputeId: number;
  };
  requestBackupInfo: {
    id: number;
    note: string;
  };
  brandInfo: {
    brandKey: string;
  };
  purchaserInfo: {
    purchaserKey: string;
  };
  userInfo: {
    userId: number;
  };
}

export enum WebSocketAction {
  DISPUTE_STATUS_UPDATE = "dispute_status_update",
  INTELLI_UPLOAD_STATUS_UPDATE = "intelli_upload_status_update",
  NEW_CONVERSATION = "new_conversation",
  BACKUP_REQUEST_STATUS_UPDATE = "backup_request_status_update",
}
